import { FieldError } from '@/components/ui/field';
import { UploadTerminImage } from '@/domain/termine/components/TerminImage/UploadTerminImage';
import { useCreateTermineFormContext } from '@/domain/termine/features/CreateTermin/shared/useCreateTermineFormContext';

export function ImageFormField() {
  const { form } = useCreateTermineFormContext();

  return (
    <form.AppField name="terminBild">
      {(field) => (
        <div className="flex flex-col gap-1">
          <form.Subscribe selector={(state) => state.values.markierung}>
            {(markierung) => (
              <UploadTerminImage
                image={field.state.value}
                variant="sheet"
                markierung={markierung}
                className="text-neutrals-700"
                onFileSelect={(file) => {
                  field.handleChange(
                    file
                      ? { file, name: file.name, contentType: file.type }
                      : null,
                  );
                  field.handleBlur();
                }}
              />
            )}
          </form.Subscribe>
          <form.Subscribe selector={(state) => [state.fieldMeta]}>
            {([fieldMeta]) => {
              const fileErrors = fieldMeta['terminBild.file']?.errors;
              return <FieldError errors={fileErrors} />;
            }}
          </form.Subscribe>
        </div>
      )}
    </form.AppField>
  );
}
